import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { RawIntlProvider } from 'react-intl';
import moment from 'moment';
import { getLanguage } from "../utils/intlUtility";
import intl from "../intl";

var LocalizationProvider = function LocalizationProvider(_ref) {
  var language = _ref.language,
      children = _ref.children,
      onError = _ref.onError,
      onLoad = _ref.onLoad,
      shouldSkipLoadWait = _ref.shouldSkipLoadWait,
      translations = _ref.translations,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;

  var _useState = useState(function () {
    return intl.getIntl();
  }),
      _useState2 = _slicedToArray(_useState, 2),
      intlValue = _useState2[0],
      setIntl = _useState2[1];

  var _useState3 = useState(!shouldSkipLoadWait),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    var lng = language || getLanguage();
    intl.init({
      language: lng,
      onError: onError,
      onLoad: onLoad,
      translations: translations,
      debug: debug
    }).then(function (_ref2) {
      var intlValueReceived = _ref2.intl;

      if (intlValueReceived) {
        setIntl(intlValueReceived);
      }

      setLoading(false);

      if (debug) {
        console.log('[Localize] Setting moment locale to', lng);
      }

      moment.locale(lng);
    });
  }, [language]);

  if (loading) {
    return null;
  } // @ts-ignore


  return React.createElement(RawIntlProvider, {
    value: intlValue,
    "data-qa": "localization-provider"
  }, children);
};

export default LocalizationProvider;